export const siteConfig = {
  name: "Vite + NextUI",
  description: "Make beautiful websites regardless of your design experience.",
  navItems: [
    {
      label: "Home",
      href: "/",
      translations: {
        en: "Home",
        ur: "ہوم",
      },
      roles: [], // No specific role required
    },
    {
      label: "Books",
      href: "/bookList",
      translations: {
        en: "Books",
        ur: "فہرست کتب",
      },
      roles: [], // No specific role required
    },
    {
      label: "Inventory",
      href: "/Inventory",
      translations: {
        en: "Inventory",
        ur: "ذخیرہ",
      },
      roles: [], // No specific role required
    },
    // {
    //   label: "Shop",
    //   href: "/shop",
    //   translations: {
    //     en: "Shop",
    //     ur: "دکانیں",
    //   },
    //   roles: [], // No specific role required
    // },
    {
      label: "Sales",
      href: "/sales",
      translations: {
        en: "Sales",
        ur: "فروخت",
      },
      roles: [], // No specific role required
    },
    // {
    //   label: "Order",
    //   href: "/orders",
    //   translations: {
    //     en: "Order",
    //     ur: "آرڈر",
    //   },
    //   roles: [], // No specific role required
    //   hasDropdown: true,
    //   dropdownItems: [
    //     {
    //       label: "Order",
    //       href: "/orders",
    //       translations: {
    //         en: "Order",
    //         ur: "آرڈر",
    //       },

    //     },
    //     {
    //       label: "Order History",
    //       href: "/order-history",
    //       translations: {
    //         en: "Order History",
    //         ur: "آرڈر ہسٹری",
    //       },
    //     }
        
    //   ]
    // },
    {
      label: "Audits",
      href: "/audit",
      translations: {
        en: "Audit Report",
        ur: "آڈٹ رپورٹ",
      },
      roles: ["admin", "superadmin"], // Restricted to admin and superadmin
    },
    {
      label: "Logs",
      href: "/logs",
      translations: {
        en: "Activity Logs",
        ur: "سرگرمی کی لاگز",
      },
      roles: ["admin", "superadmin"], // Restricted to admin and superadmin
    },
    {
      label: "Users",
      href: "/users",
      translations: {
        en: "Users",
        ur: "یوزرز",
      },
      roles: ["admin", "superadmin"], // Only visible to admins
    },
    {
      label: "Clients",
      href: "/client",
      translations: {
        en: "Clients",
        ur: "کلایئنٹس",
      },
      roles: ["superadmin"], // Only visible to 'superadmin' role
    },
  ],
  // Similar changes to navMenuItems if needed
};
